module.exports = __webpack_public_path__ + "static/img/CBC-logo.32baf4fa.png";